import React from "react";

import {
  ContainerWrapper,
  StyledDivider,
  StyledCommentsWrapper,
} from "./container.style";

import InputForm from "../inputForm/inputForm.component";
import Comment from "../comment/comment.component";
import Pagination from "../pagination/pagination.component";

const CommentsContainer = ({
  data,
  metaData,
  commentsReadonly,
  handlePostComment,
  order,
  setOrder,
  setComments,
  setPage,
}) => {
  const handleChange = (e) => {
    setOrder(e.target.value);
  };

  const replaceComment = (comment) => {
    const index = data.findIndex((c) => c.id === comment.id);
    const newComments = [...data];
    newComments[index] = comment;
    setComments(newComments);
  };

  return (
    <ContainerWrapper id="comments" data-anchor="Comments">
      <h2>Thoughts & Discussion</h2>
      {!commentsReadonly && <InputForm handlePostComment={handlePostComment} />}
      {metaData?.pagination?.totalCount > 0 && (
        <>
          <StyledDivider />
          <div className="commentsHeader">
            <h3>{metaData?.pagination?.totalCount} Comments</h3>
            <div>
              <span>Sort by:</span>
              <select onChange={handleChange} value={order}>
                <option value="by_created_at_desc">Newest</option>
                <option value="by_created_at_asc">Oldest</option>
                <option value="by_popularity_desc">Popularity</option>
              </select>
            </div>
          </div>
          <StyledCommentsWrapper>
            {data.map((comment) => (
              <Comment
                key={comment.id}
                data={comment}
                handlePostComment={handlePostComment}
                replaceComment={replaceComment}
                commentsReadonly={commentsReadonly}
              />
            ))}
          </StyledCommentsWrapper>
          <Pagination metaData={metaData} changePage={setPage} />
        </>
      )}
    </ContainerWrapper>
  );
};

export default CommentsContainer;
